import { render, staticRenderFns } from "./child_cardProduct.vue?vue&type=template&id=86929fc4&scoped=true"
import script from "./child_cardProduct.vue?vue&type=script&lang=js"
export * from "./child_cardProduct.vue?vue&type=script&lang=js"
import style0 from "./child_cardProduct.vue?vue&type=style&index=0&id=86929fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86929fc4",
  null
  
)

export default component.exports